export default __webpack_public_path__ + "static/user6-39f1f1f68184fd0798521409882b305a.jpg";